import {
	differenceInCalendarDays,
	format,
	isSameWeek,
	subWeeks,
} from "date-fns";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const useGetDateString = (createdAt: string) => {
	const { t } = useResource();
	const d = new Date(createdAt);
	const today = new Date();
	const daysDiff = differenceInCalendarDays(today, d);

	if (daysDiff === 0) {
		return t(Resources.Notifications.Date.today);
	}
	if (daysDiff === 1) {
		return t(Resources.Notifications.Date.daysAgo, { count: 1 });
	}
	if (daysDiff > 1 && isSameWeek(d, today)) {
		return t(Resources.Notifications.Date.daysAgo, { count: daysDiff });
	}
	if (isSameWeek(d, subWeeks(today, 1))) {
		return t(Resources.Notifications.Date.lastWeek);
	}
	return format(d, "dd.MM.yyyy");
};
